import { startCase } from 'lodash';
import type React from 'react';
import type { AnchorHTMLAttributes } from 'react';

import { interpolate } from '..';

import { emailLink as emailLinkBuilder } from './emailLink';

interface Email {
  emailText?: string;
  emailLink?: React.ReactElement;
}

export const emailTagTransform = <T extends AnchorHTMLAttributes<HTMLAnchorElement>>(
  key: string,
  resolved: string | null,
  domain: string | undefined | null,
  starsDomain: string,
  Component: React.ComponentType<T>
): Email => {
  let emailLink;
  let emailText;

  const textInterpolation = interpolate.find(({ type }) => {
    const lookingForKey = `contactUsText${startCase(type)}Starsdomain`;
    return key === lookingForKey;
  });

  if (textInterpolation) {
    emailText = textInterpolation.getEmail(domain || '', starsDomain);
  }

  const mailInterpolation = interpolate.find(({ type }) => {
    const lookingForKey = `contactUsMail${startCase(type)}Starsdomain`;
    return key === lookingForKey || key === 'contactUsMail' || resolved === lookingForKey;
  });

  if (mailInterpolation) {
    const email = mailInterpolation.getEmail(domain || '', starsDomain);
    emailLink = emailLinkBuilder(email, Component);
  }

  return { emailLink, emailText };
};
